import { REnv } from "routes";
import { useQueryParamsWithDefault } from "./useQueryParams";

const useLocale = () => {
  return useQueryParamsWithDefault(REnv).locale;
};

export default useLocale;
